/**
 * Walkthrough registry.
 *
 * Each entry describes one interactive tour. Tours are pure data + selectors -
 * adding a new module tour is a matter of dropping a new file alongside this
 * one and importing it into ``allTours``. No backend changes required.
 *
 * Schema (per tour):
 *   id              - stable identifier, used in URLs and persistence (kebab-case)
 *   title           - display name shown in the welcome modal and Training tab
 *   description     - short blurb shown to the user before they start
 *   estimatedMinutes- rough time estimate, displayed in the picker
 *   startRoute      - route the engine navigates to before showing step 0
 *                     (may include a query string, e.g.
 *                      "/offer-generator?type=new&dealType=Bid")
 *   steps           - array of react-joyride step objects, augmented with our
 *                     own metadata fields (e.g. ``isLast`` for engine logic,
 *                     ``clickBefore`` for in-page tab switching)
 *
 * Tour ordering: the registry order is what the Hamster Training tab shows.
 * High-level module tours come first, then per-flow deep-dives.
 */
import crmTour from './crm-tour';
import cargoTour from './cargo-tour';
import bunkersTour from './bunkers-tour';
import productTour from './product-tour';
import cargoBidOfferTour from './cargo-bid-offer-tour';
import bunkersEnquiryTour from './bunkers-enquiry-tour';
import recapTour from './recap-tour';
import deliveryTour from './delivery-tour';

export const allTours = [
    crmTour,
    cargoTour,
    bunkersTour,
    productTour,
    cargoBidOfferTour,
    bunkersEnquiryTour,
    recapTour,
    deliveryTour,
];

export const getTourById = (tourId) =>
    allTours.find((tour) => tour.id === tourId) || null;

export default allTours;
